import { Stack } from "@mui/material";
import React from "react";
import AssetVideoResolutionChip from "../../Misc/Chips/AssetChip/asset-video-resolution-chip";

export type TableCellChipVideoResolutionProps = {
  data: any;
};
const TableCellChipVideoResolution: React.FC<TableCellChipVideoResolutionProps> = (props) => {
  const sortedData = props.data.value && props.data.value.length ? [...props.data.value].sort() : [];
  return (
    <>
      <Stack direction="row" sx={{ flexWrap: "wrap", gap: 0.5, my: 1 }}>
        {sortedData.map((v: string) => (
          <AssetVideoResolutionChip key={v} label={v} resolution={v} size="small" sx={{ mr: 0.5 }} />
        ))}
      </Stack>
    </>
  );
};

export default TableCellChipVideoResolution;
